﻿(function($) {
    $.extend({
        postJSON: function (url, data, options) {
            if (_.isObject(data))
                data = JSON.stringify(data);

            var o = $.extend({
                url: url,
                type: 'POST',
                data: data,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8'
            }, options);
            var res = $.ajax(o);
            res.startTimestamp = new Date().valueOf();
            return res;
        }
    });
} (jQuery));